import React from "react";
import Game from "./Game";
  
  function GameContainer(props) {
    return <Game />
  }

export default GameContainer;
